const BROADCAST_PREFERENCES = {
  all: 'all',
  squad: 'squad',
  marine: 'marine',
};

interface BroadcastPreferenceDescription {
  [key: string]: string;
}

export const BROADCAST_PREFERENCE_DESCRIPTION: BroadcastPreferenceDescription = {
  'all': 'Standard',
  'squad': 'Squad',
  'marine': 'Marine',
};

export const BROADCAST_MINUTES = 30;

export default BROADCAST_PREFERENCES;